import { esLocale, esUsLocale } from 'ngx-bootstrap';

export class Utilidades {
	/**
	 * Agrega los filtros de AgGrid a la API Query
	 * @param filterModel AgGrid server side filter
	 * @param query objeto query de API REST
	 */
	static filter2Query(filterModel, query: any = {}) {
		Object.keys(filterModel).forEach(key => {
			const formatKey = Utilidades.replaceAll(key, '\\.', '->');

			let filter = filterModel[key].filter;

			if (filterModel[key].filterType === 'date') {
				filter = filterModel[key].dateFrom;
			}

			switch (filterModel[key].type) {
				case 'lessThan':
					query[`${formatKey}[lt]`] = filter;
					break;
				case 'greaterThan':
					query[`${formatKey}[gt]`] = filter;
					break;
				case 'lessThanOrEqual':
					query[`${formatKey}[le]`] = filter;
					break;
				case 'greaterThanOrEqual':
					query[`${formatKey}[ge]`] = filter;
					break;
				case 'contains':
					query[`${formatKey}[like]`] = `%${filter}%`;
					break;
				case 'inRange':
					let filterTo = `${filterModel[key].filterTo}`;
					if (filterModel[key].filterType === 'date') {
						filterTo = filterModel[key].dateTo;
					}
					query[`${formatKey}[eq]`] = `${filter},${filterTo}`;
					break;
				case 'notEqual':
					query[`${formatKey}[ne]`] = filter;
					break;
				default:
					if (filterModel[key].filterType === 'date') {
						query[`${formatKey}[like]`] = `%${filter}%`;
					} else {
						query[formatKey] = filter;
					}
					break;
			}
		});

		return query;
	}

	/**
	 * Reemplaza todas las ocurrencias en un texto
	 */
	static replaceAll(str, find, replace) {
		return str.replace(new RegExp(find, 'g'), replace);
	}
}
